// --- Remove ?variant= from URL so Shopify doesn't auto-select a variant ---
if (window.location.search.includes('variant=')) {
  const newUrl = window.location.origin + window.location.pathname;
  window.history.replaceState({}, document.title, newUrl);
}
// disable-auto-variant.js
(function () {
  // Utility: disable add to cart for a given form
  function disableAddButtonForForm(form) {
    if (!form) return;
    const addBtn = form.querySelector('[name="add"], button[type="submit"], [type="submit"]');
    if (addBtn) addBtn.setAttribute('disabled', 'disabled');
  }

  function enableAddButtonForForm(form) {
    if (!form) return;
    const addBtn = form.querySelector('[name="add"], button[type="submit"], [type="submit"]');
    if (addBtn) addBtn.removeAttribute('disabled');
  }

  function clearInitialSelections(selectorEl) {
    if (!selectorEl) return;
    // Uncheck radio inputs (swatches / pill options)
    selectorEl.querySelectorAll('input[type="radio"]').forEach((r) => {
      try { r.checked = false; } catch (e) {}
    });
    // Reset selects to first option (which should be placeholder if you inserted it)
    selectorEl.querySelectorAll('select').forEach((s) => {
      try { s.selectedIndex = 0; } catch (e) {}
    });
  }

  function onPickerChangeHandler(evt) {
    const selector = evt.currentTarget || evt.target.closest('variant-selects') || evt.target.closest('variant-radios');
    if (!selector) return;
    const form = selector.closest('form') || document.querySelector(`#product-form-${selector.dataset.section}`);
    // If any option still empty/unselected, keep disabled
    const anyEmpty = Array.from(selector.querySelectorAll('select, fieldset')).some((el) => {
      if (el.tagName === 'SELECT') {
        return !el.value || el.value === '';
      } else if (el.tagName === 'FIELDSET') {
        // fieldset contains radio inputs
        return !Array.from(el.querySelectorAll('input[type="radio"]')).some((r) => r.checked);
      }
      return true;
    });
    if (anyEmpty) disableAddButtonForForm(form);
    else enableAddButtonForForm(form);
  }

  // Patch variant-selects after it's defined
  customElements.whenDefined('variant-selects').then(() => {
    try {
      const proto = customElements.get('variant-selects').prototype;

      // Save original method if exists
      const origUpdateMasterId = proto.updateMasterId;

      // Override updateMasterId so it only finds a variant when all option values are present
      proto.updateMasterId = function () {
        // Ensure updateOptions has run so this.options is current
        if (typeof this.updateOptions === 'function') {
          this.updateOptions();
        }

        // If any option is missing (empty/undefined/null), do NOT auto-select a variant
        const hasEmpty = Array.isArray(this.options) && this.options.some((o) => o === undefined || o === null || o === '');
        if (hasEmpty) {
          this.currentVariant = null;
          return;
        }

        // Otherwise call original behaviour (if it exists)
        if (typeof origUpdateMasterId === 'function') {
          return origUpdateMasterId.call(this);
        } else {
          // fallback: try to compute like original Dawn might
          this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options
              .map((option, index) => {
                return this.options[index] === option;
              })
              .includes(false);
          });
        }
      };

      // For any existing instances on the page, clear selection + disable add button
      document.querySelectorAll('variant-selects, variant-radios').forEach((selector) => {
        clearInitialSelections(selector);
        const form = selector.closest('form') || document.querySelector(`#product-form-${selector.dataset.section}`);
        disableAddButtonForForm(form);

        // ensure change listener re-evaluates button state
        selector.removeEventListener('change', onPickerChangeHandler); // idempotent
        selector.addEventListener('change', onPickerChangeHandler);
      });

      // Also listen for newly injected sections (Shopify theme editor / sections)
      document.addEventListener('shopify:section:load', (evt) => {
        setTimeout(() => {
          const selector = evt.target.querySelector('variant-selects, variant-radios');
          if (selector) {
            clearInitialSelections(selector);
            const form = selector.closest('form') || document.querySelector(`#product-form-${selector.dataset.section}`);
            disableAddButtonForForm(form);
            selector.removeEventListener('change', onPickerChangeHandler);
            selector.addEventListener('change', onPickerChangeHandler);
          }
        }, 200);
      });
    } catch (e) {
      console.error('disable-auto-variant patch failed', e);
    }
  });

  // Safety: if custom element not registered yet, still try a timed fallback.
  document.addEventListener('DOMContentLoaded', () => {
    // give Dawn some time to initialize components
    setTimeout(() => {
      document.querySelectorAll('variant-selects, variant-radios').forEach((selector) => {
        clearInitialSelections(selector);
        const form = selector.closest('form') || document.querySelector(`#product-form-${selector.dataset.section}`);
        disableAddButtonForForm(form);
        selector.removeEventListener('change', onPickerChangeHandler);
        selector.addEventListener('change', onPickerChangeHandler);
      });
    }, 1200);
  });
})();
